export default "__VITE_ASSET__PxwCUjtI__"